import { render, staticRenderFns } from "./MNOMasks.vue?vue&type=template&id=565638ea&"
import script from "./MNOMasks.vue?vue&type=script&lang=ts&"
export * from "./MNOMasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports